import React from "react";
import FormTextField from "./FormTextField";

/**
 * TR telefon input atomu — sadece rakam alır, "+90 (5XX) XXX XX XX" biçimine dönüştürür.
 * Alan kodu (+90) her zaman sabittir; kullanıcı 5XX... diye 10 hane girer. Veritabanından
 * gelen "+905551234567" ve eski "05551234567" değerleri de aynı biçimde gösterilir.
 * Sunucu formatlı değeri "+90XXXXXXXXXX" olarak normalize eder.
 * @param {string} value
 * @param {(v: string) => void} onChange
 * @param {object} rest - FormTextField'a geçen diğer props
 */
export const formatTRPhone = (raw) => {
  let d = (raw || "").replace(/\D/g, "");
  if (d.length === 0) return "";
  // Ülke / trunk öneki: 0090…, 90…(12 hane), 0…
  if (d.startsWith("0090")) d = d.slice(4);
  else if (d.startsWith("90") && (String(raw).trim().startsWith("+") || d.length > 10)) d = d.slice(2);
  else if (d.startsWith("0")) d = d.slice(1);
  if (d.length > 10) d = d.slice(0, 10);
  if (d.length === 0) return "";
  let out = "+90";
  if (d.length > 0) out += " (" + d.slice(0, Math.min(3, d.length));
  if (d.length >= 3) out += ")";
  if (d.length > 3) out += " " + d.slice(3, Math.min(6, d.length));
  if (d.length > 6) out += " " + d.slice(6, Math.min(8, d.length));
  if (d.length > 8) out += " " + d.slice(8, 10);
  return out;
};

/**
 * Listelerde/detaylarda gösterim: "+905551234567" → "+90 (555) 123 45 67".
 * Tam bir TR numarası değilse (eski/bozuk kayıt) ham değer olduğu gibi döner; boşsa "".
 */
export const formatPhoneDisplay = (raw) => {
  if (raw === undefined || raw === null || String(raw).trim() === "") return "";
  const f = formatTRPhone(String(raw));
  return f.replace(/\D/g, "").length === 12 ? f : String(raw);
};

export default function PhoneInput({ value, onChange, placeholder = "+90 (5XX) XXX XX XX", inputProps, ...rest }) {
  return (
    <FormTextField
      value={formatTRPhone(value)}
      onChange={(e) => onChange(formatTRPhone(e.target.value))}
      placeholder={placeholder}
      inputProps={{ inputMode: "tel", maxLength: 19, ...(inputProps || {}) }}
      {...rest}
    />
  );
}
